


export default{
    data(){
        return{
            apis:{//接口列表
                members: '/sh/enum/member/list',//获取枚举成员列表
            },
            enums:[],//枚举成员列表
            selections: [],//选中的枚举成员
            valueMap:{},//枚举值映射
        }
    },
    model:{
        prop: 'value',
        event: 'change'
    },
    props:{
        multiple: {//允许多选
            type: Boolean,
            default: false
        },
        tag: {//以标签形式显示多选的值
            type: Boolean,
            default: true
        },
        enumCode: {//枚举编码，字符串
            type: String,
            default: null
        },
        value:{//枚举成员值
            type:[Array, Number],
            default(){
                return this.multiple ? [] : null;
            }
        },
        size:{//输入框尺寸
            type:String,
            default: 'small'
        },
        tips:{
            type:String,
            default:'请选择'
        },
        disabled:{//禁用
            type: Boolean,
            default: false
        }
    },
    watch:{
        value(){
            const me = this;
            me.setValue();
        }
    },
    mounted() {
        const me = this;
        me.enums = [];
        
        me.loadEnum();
    },
    methods: {
        loadEnum() {//获取成员列表
            const me = this;
            if(!me.enumCode){
                me.tips = '请传入枚举编码[enumCode]';
                return;
            }
            me.$post({
                url: me.apis.members,
                params:{
                    enumCode: me.enumCode,
                    page : 1
                }
            }).then(rsp => {
                me.enums = rsp.retList;
                me.valueMap = {};
                if(me.enums && me.enums.length > 0){
                    for(let i in me.enums){
                        me.$set(me.valueMap, me.enums[i].value, true);
                    }
                }
                me.setValue();
            })
        },
        getEnum(){//获取选中的枚举成员，如果允许多选，返回列表，否则返回对象
            const me = this;
            if(!me.enums || me.enums.length <= 0 || !me.selections || me.selections.length <= 0){
                return null;
            }
            if(me.multiple){
                let ems = [];
                for(let i in me.enums){
                    let em = me.enums[i];
                    if(me.selections.indexOf(em.value)){
                        ems.push(em);
                    }
                }
                return ems;
            }else{
                for(let i in me.enums){
                    let em = me.enums[i];
                    if(em.value == me.selections){
                        return em;
                    }
                }
                return null;
            }
        },
        setValue(){//设置默认值
            const me = this;
            me.selections = me.multiple ? [] : null;
            if(!me.value){
                return;
            }
            if(me.multiple){
                if(me.value instanceof Number ){
                    if(me.valueMap[me.value]){
                        me.selections.push(me.value);
                    }
                }else{
                    for(let i in me.value){
                        let v = me.value[i];
                        if(me.valueMap[v]){
                            me.selections.push(v);
                        }
                    }
                }
            }else{
                me.selections = me.valueMap[me.value] ? me.value : null;
            }
        },
        change(){//选中值发生变化时触发
            const me = this;
            me.$emit('change', me.selections);
        },
        clear(){//清空时触发
            const me = this;
			me.selections = me.multiple ? [] : null;
			me.change();
            me.$emit('clear');
        }
        
    }
}


// WEBPACK FOOTER //
// ./src/components/base/view/Enum/cmps/combo/src/combo.js